export const timezones = (state) => state.timezones
export const openingDays = (state) => state.openingDays